export default __webpack_public_path__ + "static/media/bomEx.a1e10c12.svg";